export default __webpack_public_path__ + "static/media/rick.ad778918.png";